<template>
	<div id="Infor" style="margin-top:-20px;">

		<div class="g-right-middle width800 g-ypxx">
			<p>
				<span class='ypxx-left'>姓名</span>
				<span class="ypxx-right">
					<input type="text" v-model="name" placeholder="请输入联系姓名" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'>手机号</span>
				<span class="ypxx-right">
					<input type="text" v-model="mobile" placeholder="请输入联系手机号" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'>微信号</span>
				<span class="ypxx-right">
					<input type="text" v-model="wechat" placeholder="请输入联系微信号" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'>qq号</span>
				<span class="ypxx-right">
					<input type="text" v-model="qqnumber" placeholder="请输入联系qq" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class='ypxx-left'>邮箱账号</span>
				<span class="ypxx-right">
					<input type="text" v-model="mail" placeholder="请输入联系邮箱" />
				</span>
				<div class=" clearfix"></div>
			</p>
			<!-- <p>
				<span class='ypxx-left'>联系角色</span>
				<span class="ypxx-right">
					<input type="text" v-model="role" placeholder="请输入联系角色" />
				</span>
				<div class=" clearfix"></div>
			</p> -->
			<center><input @click="ypxx" type="button" class="g-btn" value="确认提交"></center>
		</div>
	</div>
</template>
<script>
	import storage from '../../../storage/storage.js'
	import Axios from 'axios'
	export default {
		data() {
			return {
				name: [],
				mobile: [],
				wechat: [],
				qqnumber: [],
				mail: [],
				// role: [],
				uid: ''
			}
		},

		methods: {

			ypxx() {
				var api = 'https://api.yopoo.cn/api/centre/crewcontact'

				let ypxxform = {
					name: [this.name],
					mobile: [this.mobile],
					wechat: [this.wechat],
					qqnumber: [this.qqnumber],
					mail: [this.mail],
					// role: [this.role],
					uid: storage.get('newuid')
				}
				Axios.post(api, ypxxform).then((res) => {
					// console.log(res.data)
					if (res.data.code == '200') {
						this.$message({ //提示发送验证码成功信息
							message: res.data.msg,
							type: 'success',
							center: true
						});
						setTimeout(() => {
							this.$router.push({
								path: '/group_admin/release', //填写完信息后跳转发布列表页面
							}) //登录后跳转页面
						}, 200);
						storage.del('uid') //清楚后台返回的存储uid信息
					}
					if (res.data.code == '202') {
						this.$message({ //提示发送验证码成功信息
							message: res.data.msg,
							type: 'error',
							center: true
						});
					}
				}).catch((res) => {})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/group_admin/edit/G_Infor.vue